import { createAction } from '@reduxjs/toolkit';
import { requiredEmptyAllowedString, requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
const instantResultsRegisterDefinition = {
    id: requiredNonEmptyString,
};
const instantResultsQueryDefinition = {
    ...instantResultsRegisterDefinition,
    q: requiredEmptyAllowedString,
};
export const registerInstantResults = createAction('instantResults/register', (payload) => validatePayload(payload, instantResultsRegisterDefinition));
export const updateInstantResultsQuery = createAction('instantResults/updateQuery', (payload) => validatePayload(payload, instantResultsQueryDefinition));
export const clearExpiredResults = createAction('instantResults/clearExpired', (payload) => validatePayload(payload, instantResultsRegisterDefinition));
